enum MedicalItemSubtypeEnum {
    ProblemAndCondition_Ongoing = 1,
    ProblemAndCondition_Past = 2,
    ProblemAndCondition_SurgicalPast = 3,
    ProblemAndCondition_Psychiatric = 4,
    ProblemAndCondition_Gynecology = 5
}

export { MedicalItemSubtypeEnum };
